<template>
    <!--<div class="h_icon">
        <div style="cursor: pointer" onclick="window.location.href='https://www.youtube.com/';" class="snsimg_1"></div>
        <div style="cursor: pointer" onclick="window.location.href='https://section.blog.naver.com/';"
             class="snsimg_2"></div>
        <div style="cursor: pointer" onclick="window.location.href='https://www.facebook.com/';" class="snsimg_3"></div>
    </div>-->
    <div class="h_icon">
        <div @click="openUrl(icon.i_url)" class="snsimg" v-for="icon in iconList" :key="`icon${icon.i_idx}`"
        :style="`background-image:url(${returnIconImage(icon)})`"></div>
    </div>
</template>
<script>
    import imageOption from "@/mixins/imageOption";
    import util from "@/mixins/util";
    export default {
        name: "WebinkListComponent",
        mixins: [imageOption],
        props: {},
        data() {
            return {
                iconList: [],
            }
        },
        created() {

        },
        mounted() {
            this.getIcon()
        },
        computed: {},
        methods: {
            getIcon() {
                let params = {}
                try {
                    this.$api.$icon.getWebIcon(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.type == 1) {
                            this.iconList = res.List
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            returnIconImage(icon){
                return icon.hasOwnProperty('Files') ? `${icon.Files[0].org_url}?${this.setImageOptions(48, 48, 'png')}` : ''
            },
            movePage(icon){
                window.location.href(icon.url)
            },
            openUrl(url) {
                if (!util.isEmpty(url)) {
                    if (url.includes('https://') || url.includes('http://')) {
                        window.open(url, '_blank')
                    }
                    window.open(`http://${url}`, '_blank')
                }
            }
        },
        watch: {}
    }
</script>

<style lang="scss">
.p_header{
    .h_icon {
        margin-top: 5px;
        vertical-align: middle;
        margin-left: 21px;
        display: inline-block;
        min-width: 101px;
        height: 33px;
        text-align: left;
        .snsimg{
            margin-left: 10px;
            display: inline-block;
            background-repeat: no-repeat;
            background-size: contain;

            width: 24px;
            height: 24px;
            cursor: pointer;
            &:first-child{
                margin-left: 0;
            }
        }


    }
    }
</style>